import { http, HttpResponse } from 'msw';

import type { LeadData } from 'services/lead/queries/useLeadData/useLeadData.interface';

const mockLeadData: LeadData = {
    email: 'jane@example.com',
    full_name: 'Jane Smith',
    phone_number: '(555)-123-4567',
    form_fields: {
        funnel_workflow_ssc: {
            state: 'CA',
            us_citizen_or_permanent_resident: true,
            reside_outside_us: false,
            has_business_setup: false,
            business_type: 'llc',
            ownership_structure: 'sole',
            has_a_team: false,
            number_of_w2_employees: 0,
            number_of_1099_contractors: 0,
            additional_w2_income: 0,
            revenue: 150000,
            expenses: 50000,
        },
    },
    control_data: {
        funnel_workflow_ssc: {
            is_qualified: true,
            best_fit_plan: ['scorp'],
            recommended_plans: ['scorp', 'llc'],
        },
    },
};

export default {
    leadDataGet: http.get('*/lead-data/', () => HttpResponse.json(mockLeadData satisfies LeadData)),
    leadDataUpsert: http.post('*/lead-data/', () => HttpResponse.json(mockLeadData satisfies LeadData)),
};
